import React, {useContext, useEffect, useRef, useState} from "react";
import {Form} from "react-bootstrap";
import {store} from "../../Store/store";


export default function TextEditor(props) {
    const [inputValue, setInputValue] = useState(props.value);
    const stateObj = useContext(store);
    const isRequestInProgress = stateObj.state.isRequestInProgress;
    const textBoxDisabled = isRequestInProgress.state && isRequestInProgress.rowId === props.row.id;
    const inputRef = useRef();


    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    const updateInput = () => {
        props.handleOnEdit(false);
        props.toggleCommCheckBox(false, props.row.id);
        inputValue ? props.onUpdate(inputValue) : props.onUpdate('');

    };

    useEffect(() => {
        inputRef.current.focus();
        props.toggleCommCheckBox(true, props.row.id);
    }, [])

    return (<div>
        <Form.Control disabled={textBoxDisabled}
                      ref={inputRef} size='sm' value={inputValue} onChange={handleChange} onBlur={updateInput}
                      onFocus={props.handleOnEdit(true)}/>
    </div>);
}
